import { Box, Stack, Typography, useMediaQuery } from "@mui/material"
import BaseModal from "../BaseModal/BaseModal"
import pwaIPhone from "../../assets/images/pwa-iphone.gif"
import * as Styled from "./PWAModal.styles"
import QRCode from "../../assets/images/pwa-qr-code.png"

interface PWAModalsProps {
    openModal: boolean
    onDownloaded: any
    onDelayDownload?: any
    onClose: any
}

const PWAModal = ({ openModal, onDownloaded, onDelayDownload }: PWAModalsProps) => {
    const isDesktop = useMediaQuery((theme: any) =>
        theme.breakpoints.up("desktop")
      );



    const mobileContainer = (): JSX.Element => {
        return (
            <Stack direction="column" gap={1} sx={{ alignItems: "center", paddingTop: "15px" }}>

                <Typography sx={{ fontFamily: 'Slalom Sans', fontSize: "16px", fontWeight: 700, lineHeight: "100%", display: "flex" }}>Add Gather App to Your Home Screen</Typography>
                <Typography sx={{ fontFamily: 'Slalom Sans', fontSize: "14px", fontWeight: 400, lineHeight: "20px", display: "flex" }}>Follow the instructions below</Typography>
                <Box>
                    <img width="258px" height="529px" src={pwaIPhone} alt="PWA iPhone" />
                </Box>
            </Stack>
        )
    }

    const desktopContainer = (): JSX.Element => {
        return (
            <Box>

                <Stack direction="column" gap={2} sx={{ alignItems: "center", display: "flex", width: "100%"}} >
                    <Typography sx={{ fontFamily: 'Slalom Sans', fontSize: "24px", fontWeight: 700, lineHeight: "32px", display: "flex" }}>Add Gather App to your home screen</Typography>
                    <Stack direction="row" display="flex" flexShrink={1}>
                        <Box width="414px" display="flex" justifyContent="center">
                            <img width="258px" height="529px" src={pwaIPhone} alt="PWA iPhone" />
                        </Box>
                        <Box sx={{ width: "414px"}} flexShrink={1}  height="529px" >
                            <Styled.QRContainer width="100%" flexShrink={1} display="flex" justifyContent="center" alignItems="center">
                                <Box>
                                    <img alt="QR sign up code" height="159px" src={QRCode}></img>
                                    <Styled.QRCode >Scan the QR code</Styled.QRCode>
                                </Box>
                            </Styled.QRContainer>
                        </Box>
                    </Stack>
                    <Stack direction="row" sx={{ justifyContent: "center" }} gap={4}>

                        <Styled.BaseSubtitleActionText
                            variant="modalSubtitle"
                            onClick={onDelayDownload}
                        >
                            <Box>
                                Remind me later
                            </Box>
                        </Styled.BaseSubtitleActionText>                    
                        <Styled.DesktopButton onClick={onDownloaded} variant="contained">Done</Styled.DesktopButton>

                    </Stack>
                </Stack>


            </Box>


        )
    }

    return (
        <><BaseModal padding="36px 40px 24px 40px" desktopWidth="908px" tabletWidth="100%" mobileWidth="100%" open={openModal} onClose={onDelayDownload}>

            {isDesktop ? desktopContainer() :  mobileContainer()  }

        </BaseModal></>
    )
}

export default PWAModal;